import CalcForm from "./CalcForm";
import RevenueResult from "./RevenueResult";
import AllMetrics from "./AllMetrics";
import { RevenueCalculatorProvider } from "./context/context";
import styles from "./index.module.scss";

const RevenueCalculator = () => {
  return (
    <RevenueCalculatorProvider>
      <div className={styles.wrapper} id="revenue-calculator">
        <div className={styles.results}>
          <CalcForm />
          <RevenueResult />
        </div>

        <AllMetrics />
      </div>
    </RevenueCalculatorProvider>
  );
};

export default RevenueCalculator;
